module.exports = __webpack_public_path__ + "img/rw2024.ae9accf1.png";